import React, { PropTypes } from 'react';
import ingame from './../casino/ingame.js';

const GameLoader = (props) => {
	const { gameMode, gameCode } = props.match.params;

	ingame.loadGame(gameCode, gameMode);

	return (
		<div id="gameloader" />
	);
};

GameLoader.propTypes = {
	params: PropTypes.object
};

export default GameLoader;



// WEBPACK FOOTER //
// ./mobile-core/src/components/game-loader.js